export var concat = function concat(second) {
  return function (first) {
    return first.concat(second);
  };
};
export var split = function split(test, left, right) {
  return function (first) {
    return first.split(test, left, right);
  };
};